export default __webpack_public_path__ + "static/media/CL02.1.bc9f4802.mp3";